import React from 'react'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Old/Colors'

import { StyledTab, StyledTabs } from '../styles'
import { Refresh } from './Refresh'

export const TabsButtons = props => {
  const { data, value, handleTabSwitch, hasNewRelease, mutate, context } = props

  if (context !== 'farm') {
    return (
      <StyledTabs value={value} onChange={handleTabSwitch}>
        <StyledTab label={<Icon size="large" name="cloud-sync" />} />
        {/* Release Notes */}
        <StyledTab
          label={<Icon size="large" name="gift" color={hasNewRelease ? Colors.help : null} />}
        />
        <Refresh value={value} mutate={mutate} handleTabSwitch={handleTabSwitch} />
      </StyledTabs>
    )
  }
  return (
    <StyledTabs value={value} onChange={handleTabSwitch}>
      {/* Herd */}
      <StyledTab label={<Icon name="animal" size={21} />} count={data?.unread_animal_alerts} />
      {/* System */}
      <StyledTab
        label={<Icon size="large" name="router-wireless" />}
        count={data?.unread_system_alerts}
      />
      {/* Jobs */}
      <StyledTab label={<Icon size="large" name="cloud-sync" />} />
      {/* Release Notes */}
      <StyledTab
        label={<Icon size="large" name="gift" color={hasNewRelease ? Colors.help : null} />}
      />
      <Refresh value={value} mutate={mutate} handleTabSwitch={handleTabSwitch} />
    </StyledTabs>
  )
}
